export default "__VITE_ASSET__kXVrI_CQ__"